import { useEffect } from 'react';
import { useStoreState } from '../../../models/hooks';
import { useMeetContext } from '../MeetContext';
import { VideoEffectStore } from './store/videoEffectModel';

export function LocalStateSync() {
  const { localTracks } = useMeetContext();
  const setLocalTracks = VideoEffectStore.useStoreActions((actions) => actions.setLocalTracks);
  const setParticipantId = VideoEffectStore.useStoreActions((actions) => actions.setParticipantId);

  const user = useStoreState((state) => state.app.user);
  const participantId = (user?.anonymousUser ? user.email : user?.id) || null;

  useEffect(() => {
    setLocalTracks(localTracks);
  }, [localTracks, setLocalTracks]);

  useEffect(() => {
    setParticipantId(participantId);
  }, [participantId, setParticipantId]);

  return null;
}
